/*
 * @Author: cyerogy cyerogy@163.com
 * @Date: 2025-04-04 10:22:27
 * @LastEditors: cyerogy cyerogy@163.com
 * @LastEditTime: 2025-04-04 10:35:20
 * @FilePath: \projectorder\src\utils\auth.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { setLocalStorge, getLocalStorge, removeLocalStorge } from "./validate";
import Cookies from "js-cookie";
const UserLoginToken = "dev_purchaseorder_userInfo";
const TokenKey = process.env.NODE_ENV == "development" ? "dev_purchaseorder_token" : "csrftoken";
export function getToken() {
  const info = Cookies.get(TokenKey);
  if (info) {
    return info;
  } else {
    return null;
  }
}
export function encodex(input) {
  let keystrobj = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let output = "";
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;
  input = _utf8_encode(input);
  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;
    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output = output +
      keystrobj.charAt(enc1) + keystrobj.charAt(enc2) +
      keystrobj.charAt(enc3) + keystrobj.charAt(enc4);
  }
  return output;
}
// 登录验证用
function _utf8_encode(string) {
  string = string.replace(/\r\n/g, "\n");
  var utftext = "";
  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);
    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if ((c > 127) && (c < 2048)) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }

  }
  return utftext;
}

export function setToken(info) {
  console.log()
  return Cookies.set(TokenKey, info.access_token, {
    expires: info.expires_in / 86400
  });
}

export function removeToken() {
  //清除所有的cookie
  Object.keys(Cookies.get()).forEach(cookie => {
    Cookies.remove(cookie);
  });
  // Cookies.remove(TokenKey);
}

export function setUserLoginInfo(info) {
  if (typeof info == "object") {
    info = JSON.stringify(info);
  }
  setLocalStorge(UserLoginToken, info);
}

// export function 
export function getUserLoginInfo() {
  return getLocalStorge(UserLoginToken);
}

export function removeUserLoginInfo() {
  removeLocalStorge(UserLoginToken);
}